import type { AriaRole, ReactNode } from "react";
import { cn } from "../lib/cn";

export interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: ReactNode;
  action?: ReactNode;
  tone?: "primary" | "danger";
  role?: AriaRole;
  className?: string;
}

/** Says what is missing and what to do next. */
export function EmptyState({ icon, title, description, action, tone = "primary", role, className }: EmptyStateProps) {
  return (
    <div role={role} className={cn("flex flex-col items-center px-4 py-10 text-center md:py-14", className)}>
      {icon ? (
        <div className={cn("mb-4 flex size-12 items-center justify-center rounded-full [&_svg]:size-6", tone === "danger" ? "bg-danger-soft text-danger" : "bg-primary-soft text-primary-text")}>{icon}</div>
      ) : null}
      <h3 className="text-base font-semibold text-fg">{title}</h3>
      {description ? <p className="mt-1 max-w-sm text-sm text-fg-muted">{description}</p> : null}
      {action ? <div className="mt-5">{action}</div> : null}
    </div>
  );
}
